import { type IAdvancedRichText } from '../IAdvancedRichText';
import { postprocessRichTextAdvancedHtml } from './postprocess-html/postprocessRichTextAdvancedHtml';
import { RichTextConditional } from './RichTextConditional';
import { toAdvancedRichText } from './toAdvancedRichText';

export interface IRichTextAdvancedRenderProps {
  text?: IAdvancedRichText | string;
  /** Flag per indicare se i paragrafi annidati devono avere una formattazione inline*/
  inline?: boolean;
  /** Flag che indica se l'elemento renderizzato deve essere stilizzato */
  hasCustomFont?: boolean;
}

/**
 * Renderizza in modo centralizzato i testi avanzati (creati con l'editor
 * RTE avanzato).
 * @param inline Flag per indicare se i paragrafi annidati devono avere una formattazione inline
 * @param hasCustomFont Flag che indica se l'elemento renderizzato deve essere stilizzato
 */
export function RichTextAdvancedRender(props: IRichTextAdvancedRenderProps) {
  const { inline, hasCustomFont, text } = props;

  if (!text) return null;

  return (
    <span>
      {postprocessRichTextAdvancedHtml(toAdvancedRichText(text)).map(
        (item, index) => (
          <RichTextConditional
            key={index}
            item={item}
            index={index}
            inline={inline}
            isInfoIcon={item.type === 'info'}
            hasCustomFont={hasCustomFont}
          />
        ),
      )}
    </span>
  );
}
